import React, {useState, useRef} from 'react'
import firebase from './../../../../config/fbConfig'
import './newCategory.css'

const db = firebase.firestore(); 

function NewCategory(props) {
    const [uploadChoiceCategory, setUploadChoiceCategory] = useState(0) // 0 Means the user didn't pick his way, 1 means by URL Link, 2 means by actually uploading
    const title = useRef(null)
    const isHidden = useRef(null)
    const CategoryURL = useRef({tagName: null})
    
    // Used when the user wants to upload a local file for category's pic
    let uploadCategoryPic = (e, title) => {
        e.preventDefault();
        let fileCategory = document.getElementById('fileCategory');
        let file = fileCategory.files[0];
        let progressElem = document.getElementById('progressWrapperCategory').firstChild;


        if (window.location.href.includes('/en')) { 
            if (title==="") {
                alert("You must enter a category title before uploading.");
                return;
            }
            
            if (file==null) {
                alert(`You haven't uploaded any picture yet.`);
                return;
            }
            
            if (file.name.split('.').length!==2) {
                alert("You are not allowed to have . in your filename");
                return;
            }
        } else {
            if (title==="") {
                alert("עליך להוסיף שם לקטגוריה.");
                return;
            }
            
            if (file==null) {
                alert(`לא העלאת שום תמונה עדיין.`);
                return;
            }
            
            if (file.name.split('.').length!==2) {
                alert("אסור שיהיה נקודה בשם קובץ התמונה, נא למחוק אותו ולנסות לעלות שוב");
                return;
            }
        }
        
        
        let chosenCategory = title.replace(/\s/g, ''); // To remove the spaces from chosen category to actually it valid name for folder in Firebase Storage
        
        if (file.type.match(/image/) && file.type !== 'image/svg+xml') {
            // Reset to default state before initial search
            progressElem.parentNode.style.display = 'block';
            progressElem.style.backgroundColor = '#21ba45';
            progressElem.style.width = '0%';
            progressElem.innerHTML = "";
            document.body.style.cursor = "wait";

            var reader = new FileReader();
            reader.readAsDataURL(file); 
            reader.onloadend = function() {
                var base64data = reader.result;
                const resizePic = firebase.functions().httpsCallable('resizePic');
                let newFilename = file.name.split('.')[0] + '.jpeg';
                
                resizePic({file: base64data, resize: 450})
                .then(res => {
                    let uploadTask = firebase.storage().ref(chosenCategory + '/' + newFilename).putString(res.data, 'base64', {contentType:'image/jpeg'});

                    uploadTask.on('state_changed', function(snapshot) {
                    let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    progressElem.style.width = progress + '%';
                    console.log('Upload is ' + progress + '% done');
        
                    if (progress == 100) {
                        let completed = document.createElement('p');
                        if (window.location.href.includes('/en')) { 
                            completed.innerHTML = "Success !";
                        } else {
                            completed.innerHTML = "הושלם !";
                        }
                        progressElem.appendChild(completed);
                    }
        
                    }, function(error) {
                        progressElem.style.backgroundColor = 'red';
                        progressElem.style.width = '100%';
                        document.body.style.cursor = "default";
                    }, function() {
                    // Handle successful uploads on complete
                    // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                    uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                        console.log('File available at', downloadURL);
                        CategoryURL.current = downloadURL;
                        document.body.style.cursor = "default";
                      });
                    });

                })
                .catch(err => {
                    if (window.location.href.includes('/en')) { 
                        alert("There's an error uploading this picture")
                    } else {
                    alert("שגיאה בהעלאת הקובץ");
                    }
                    console.log("There's an error", err);
                    progressElem.style.width = '100%';
                    progressElem.style.backgroundColor = 'red';
                    document.body.style.cursor = "default";
                }); 
            }
           
        } else {
            if (window.location.href.includes('/en')) { 
                alert("The file you are trying to upload isn't a picture.");
            } else {
            alert("הקובץ שאתה מנסה לעלות הוא לא מסוג תמונה."); 
            }  
        }
        
    }

    // Used when the user wants to add his category to the database
    let addCategory = (e, title) => {
        e.preventDefault();
        if (window.location.href.includes('/en')) { 
            if (title === "") {
                alert("You must enter a title for the category.")
                return;
            }
    
            if (CategoryURL.current.tagName === null) {
                alert("You must upload a picture.")
                return;
            }
        } else {
            if (title === "") {
                alert("עליך להוסיף שם לקטגוריה.")
                return;
            }
    
            if (CategoryURL.current.tagName === null) {
                alert("עליך להעלות תמונה לקטגוריה.")
                return;
            }
        }
       

        let deliveredCategory = {
            title,
            isHidden: isHidden.current.checked,
            CategoryURL: CategoryURL.current.tagName==="INPUT" ? CategoryURL.current.value : CategoryURL.current,
            products: []
        }

        props.menu.push(deliveredCategory);  // Editing the menu from props, to update the menu also for other sections in Editmenu
        let categoryLang = 'categories' + props.chosenLang;
        db.collection('menu').doc('categories').update({
            [categoryLang]: firebase.firestore.FieldValue.arrayUnion(deliveredCategory)
        });

        if (window.location.href.includes('/en')) { 
            alert(`${title} category succesfully added!`);
        } else {
            alert(`הקטגוריה - ${title} - נוספה בהצלחה!`);
        }    
        

        // Reset
        document.getElementById('newCategory').reset();
        if (CategoryURL.current.tagName!="INPUT") {
            let progressElem = document.getElementById('progressWrapperCategory').firstChild;
            progressElem.style.backgroundColor = '#21ba45';
            progressElem.style.width = '0%';
            progressElem.parentNode.style.display = 'none';
        }
    }


if (window.location.href.includes('/en')) { 
    return (
        <form id="newCategory">
            <div className="middleWrapper">
                <label>Category's title <span>*</span> </label>
                <input type="text" ref={title}/>
                
                <hr/>

                <label style={{display: 'inline-block'}}>Hide category?</label>
                <input name="hideCategory" type="checkbox" defaultChecked ref={isHidden}/>
                
                <hr/>

                {uploadChoiceCategory==0 &&
                <React.Fragment>
                    <label>Upload a Picture <span>*</span> </label>
                    <div className="fileWrapper" style={{border: '1px solid gray', backgroundColor: 'white'}}>
                    <button style={{left: '0', borderBottomRightRadius: '15px', borderTopRightRadius: '15px', borderBottomLeftRadius: '0', borderTopLeftRadius: '0'}} onClick={() => setUploadChoiceCategory(1)}>URL Link</button>
                    <button onClick={() => setUploadChoiceCategory(2)}>Upload Local File</button>
                    </div>
                </React.Fragment>
                }

                {uploadChoiceCategory==1 &&
                <React.Fragment>
                    <label>Upload a Picture (URL Link) <span>*</span> </label>
                    <input type="text" ref={CategoryURL}/>
                </React.Fragment>
                }

                {uploadChoiceCategory==2 &&
                <React.Fragment>
                    <label>Upload a Picture (Local File) <span>*</span> </label>
                    <div className="fileWrapper">
                        <input type="file" id="fileCategory" className="relativeInput"/>
                        <button onClick={() => uploadCategoryPic(window.event, title.current.value)} style={{width: '85px'}}><span>UPLOAD</span></button>
                    </div>
                    <div id="progressWrapperCategory" style={{display: 'none'}}>
                        <div></div>
                    </div>
                </React.Fragment>
                }

                <hr/>

                <button onClick={(e) => addCategory(window.event, title.current.value)} id="mainButton">Add Category</button>
            </div>
            
        </form>    
    )
}

    return (
        <form id="newCategory">
            <div className="middleWrapper">
                <label>שם הקטגוריה <span>*</span> </label>
                <input type="text" ref={title}/>
                
                <hr/>

                <label style={{display: 'inline-block'}}>הסתר קטגוריה?</label>
                <input name="hideCategory" type="checkbox" defaultChecked ref={isHidden}/>
                
                <hr/>

                {uploadChoiceCategory==0 &&
                <React.Fragment>
                    <label>העלאת תמונה <span>*</span> </label>
                    <div className="fileWrapper" style={{border: '1px solid gray', backgroundColor: 'white'}}>
                    <button style={{left: '0', borderBottomRightRadius: '15px', borderTopRightRadius: '15px', borderBottomLeftRadius: '0', borderTopLeftRadius: '0'}} onClick={() => setUploadChoiceCategory(1)}>URL לינק</button>
                    <button onClick={() => setUploadChoiceCategory(2)}>העלה קובץ מקומי</button>
                    </div>
                </React.Fragment>
                }

                {uploadChoiceCategory==1 &&
                <React.Fragment>
                    <label>העלאת תמונה (URL לינק) <span>*</span> </label>
                    <input type="text" ref={CategoryURL}/>
                </React.Fragment>
                }

                {uploadChoiceCategory==2 &&
                <React.Fragment>
                    <label>העלאת תמונה (קובץ מקומי) <span>*</span> </label>
                    <div className="fileWrapper">
                        <input type="file" id="fileCategory" className="relativeInput"/>
                        <button onClick={() => uploadCategoryPic(window.event, title.current.value)} style={{width: '85px'}}><span>העלאה</span></button>
                    </div>
                    <div id="progressWrapperCategory" style={{display: 'none'}}>
                        <div></div>
                    </div>
                </React.Fragment>
                }

                <hr/>

                <button onClick={(e) => addCategory(window.event, title.current.value)} id="mainButton">הוסף קטגוריה</button>
            </div>
            
        </form>
    )
}

export default NewCategory
